export default __webpack_public_path__ + "static/media/gallery_02.61432a61.jpg";